import React from "react";
import Image from "next/image";
import { container_classname } from "../constants";
import { FaAngleRight } from "react-icons/fa6";

export interface Product {
    imageUrl: string;
    title: string;
    description: string;
    externalLink?: string;
    headerBackground?: boolean;
}
const sampleProductCardData: Array<Product> = [
    {
        title: "Click-to-WhatsApp ads",
        description: "Drive student interest and engagement on WhatsApp directly from Meta ads.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/click-whatsapp-ads.png",
        externalLink: "https://gallabox.com/click-to-whatsapp-ads",
    },
    {
        title: "Broadcast",
        description: "Amplify your announcements in a few clicks ensuring maximum reach.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/broadcast.png",
        externalLink: "https://gallabox.com/whatsapp-broadcast",
    },
    {
        title: "Drip marketing",
        description: "Nurture student prospects interest by scheduling timely messages.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/drip-marketing.png",
        externalLink: "https://gallabox.com/whatsapp-drip-marketing",
    },
    {
        title: "Flows",
        description: "Collect student info for admissions, interviews, and counseling sessions.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/whatsapp-flow.png",
        externalLink: "https://gallabox.com/whatsapp-flows",
    },
    {
        title: "Chatbot",
        description: "Answer FAQs and important course-related queries on WhatsApp with no-code AI bots.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/bot.png",
        externalLink: "https://gallabox.com/whatsapp-chatbot",
    },
    {
        title: "Shared team inbox",
        description: "Support and onboard students as a team with a single, AI-powered inbox.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/inbox.png",
        externalLink: "https://gallabox.com/whatsapp-shared-inbox",
    },
    {
        title: "AI rewrite",
        description: "Edit responses with our built-in Gen AI and respond to aspirants in multiple languages.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/gallabox-gen-ai.png",
        externalLink: "https://gallabox.com/whatsapp-ai-chatbot",
    },
    {
        title: "Payments",
        description: "Request course fee and send payment reminders automatically to parents on WhatsApp.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/group.png",
        externalLink: "https://gallabox.com/whatsapp-payments",
    },
];

const ProductSection: React.FC<{ productCardData?: Array<Product>; title?: string; description?: string; gridCols?: string }> = ({
    productCardData = sampleProductCardData,
    title,
    description,
    gridCols = "md:grid-cols-4",
}) => {
    return (
        <section
            style={{
                background: "linear-gradient(262deg, #396AFF -15.76%, #00238D 9.06%, #000 89.79%)",
                borderRadius: "4px 4px 0 0",
            }}
            className="py-20"
        >
            <h2 className={`${container_classname} text-white mb-3 md:text-6xl text-4xl`} style={{ fontFamily: "Degular Display" }}>
                {title}
            </h2>
            <p className={`${container_classname} text-white font-semibold`}>{description}</p>
            <div className={`${container_classname} grid ${gridCols} gap-6 py-10`}>
                {productCardData && productCardData.map((product, idx) => <Product key={idx} {...product} />)}
            </div>
        </section>
    );
};

export default ProductSection;

const Product: React.FC<Product> = ({ title, description, imageUrl, externalLink, headerBackground }) => {
    return (
        <section className="bg-white rounded">
            <div
                className="px-6 py-5 flex items-center rounded"
                style={{
                    background: headerBackground ? " " : "linear-gradient(103deg, #EDF1FF 84.45%, #84A2FF 136.43%)",
                }}
            >
                <Image src={imageUrl} alt={title} width={48} height={48} className="h-12" />
            </div>

            <div className="p-5 flex flex-col">
                <p className="mb-2 text-xl font-semibold">{title}</p>

                <p className="mb-8 mt-1" style={{ minHeight: "70px" }}>
                    {description}
                </p>
                {externalLink && (
                    <a href={`${externalLink}`} className="text-blue-600 flex items-center gap-x-1">
                        Know more <FaAngleRight color="blue" size={12} />
                    </a>
                )}
            </div>
        </section>
    );
};
